<template>
  <v-list-item :to="props.location" class="px-3" :prepend-icon="null">
    <div class="d-flex justify-start align-center ga-2">
      <v-icon v-if="props.iconName" :icon="props.iconName" />
      <img v-else-if="props.iconSrc" :src="props.iconSrc" width="24" />
      <p :style="{ fontSize: '0.9rem' }">{{ props.text }}</p>
    </div>
  </v-list-item>
</template>

<script setup lang="ts">
type MainMenuEntryProps = {
  iconName?: string
  iconSrc?: string
  text: string
  location: { name: string }
}
const props = defineProps<MainMenuEntryProps>()
</script>
